import React from "react";
import "../App.css";
import i18next from "../i18n";
import { Helmet } from "react-helmet-async";
import EAA_logo from "../images/EAA.png";
import docengine_illustration from "../images/illustrations/docengine_illustration.svg";
import docengine_illustration_vertical from "../images/illustrations/docengine_illustration_verticle.svg";
import Button from "../components/Button";
import FeatureCards from "../components/FeatureCards";
import standardizeArt from "../images/illustrations/docengine/feature-standardize.svg";
import integrationArt from "../images/illustrations/docengine/feature-integration.svg";
import valueArt from "../images/illustrations/docengine/feature-value.svg";
import SubLogo from "../components/SubLogo";
import productIllustration from "../images/illustrations/docengine/product-docengine.svg";
import { useNavigate } from "react-router-dom";

function DocEngine() {
  const date = new Date();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>{i18next.t("pages.docengine.title")}</title>
        <meta
          name="description"
          content={i18next.t("pages.docengine.description")}
        />
        <link rel="canonical" href="https://xperconsulting.no/docengine" />
      </Helmet>
      <div className="container max-w-xl flex flex-col gap-8 pt-36 pb-12 items-center text-main-dark md:flex-row">
        <div className="w-full md:w-3/5 text-left  ">
          <h1 className="sr-only">
            {i18next.t("pages.docengine.title")}
          </h1>
          <SubLogo product="DocEngine" />
          <p className="text-xl text-secondary">
            {i18next.t("pages.docengine.description")}
          </p>
        </div>
          <div className="flex w-full justify-center md:w-2/5">
            <img src={productIllustration} alt="" aria-hidden="true" width="400" height="200" className="h-auto w-full max-w-[25rem]" />
          </div>
      </div>

    

      <div className=" py-24">
        <div className="container max-w-md mx-auto flex flex-col justify-start text-main-dark text-left mb-24">
          <h2 className="text-3xl font-bold mb-2">
            {i18next.t("pages.docengine.intro.title")}
          </h2>
          <p className="text-lg mb-0">
            {i18next.t("pages.docengine.intro.description")}
          </p>
        </div>
          <h3 className="text-2xl font-bold my-8 text-main-dark">
            {i18next.t("pages.docengine.intro.problem")}
          </h3>
        <div className="container max-w-[100rem] px-4 md:px-6">
          <div className="w-full">
            <img
              src={docengine_illustration}
              alt={i18next.t("pages.docengine.intro.illustrationAlt")}
              className="hidden h-auto w-full md:block"
            />
            <img
              src={docengine_illustration_vertical}
              alt={i18next.t("pages.docengine.intro.illustrationAlt")}
              className="block h-auto w-full px-8 md:hidden"
            />
          </div>
        </div>
        <div className="container max-w-md mx-auto">
          <p className="text-md text-secondary pt-4 mb-0">
            {i18next.t("pages.docengine.intro.illustrationCaption")}
            <a href="./artikler/gjor-dokumentene-dine-tilgjengelige" className="underline underline-offset-2 text-main">
              {i18next.t("pages.docengine.intro.problemLink")}
            </a>
          </p>
        </div>
      </div>
       
      <FeatureCards
        title="pages.docengine.featureCards.title"
        cta={{
          title: "pages.docengine.featureCards.cta.title",
          description: "pages.docengine.featureCards.cta.description",
          label: "pages.docengine.featureCards.cta.button",
          onClick: () => navigate("/skjema/kontakt-oss"),
        }}
        items={[
          // To restore an original icon, uncomment its row and comment out the illustration row below it.
          // { icon: "pdf", key: "pages.docengine.featureCards.standardize", tone: "warm" },
          { illustration: standardizeArt, key: "pages.docengine.featureCards.standardize", tone: "warm" },
          // { icon: "integration", key: "pages.docengine.featureCards.integration", tone: "warm" },
          { illustration: integrationArt, key: "pages.docengine.featureCards.integration", tone: "warm" },
          // { icon: "value", key: "pages.docengine.featureCards.value", tone: "warm", list: true, listStyle: "standard" },
          { illustration: valueArt, key: "pages.docengine.featureCards.value", tone: "warm", list: true, listStyle: "standard" },
        ]}
      />

    <div className="container max-w-md mx-auto my-36">
        <div className="mx-auto flex flex-col md:flex-row justify-between items-center text-main-dark gap-4 text-lg py-16 px-6 md:px-16 bg-gray  rounded-xl">
          <div className="w-full md:w-4/5 text-left flex flex-col">
            <h2 className="text-3xl font-bold">
              {i18next.t("pages.docengine.eaa.title")}
            </h2>
            <p className="text-contrast-ink font-bold mb-0">
              {i18next.t("pages.docengine.eaa.date")}
              { i18next.t("pages.docengine.eaa.dateText.past")}
              {i18next.t("pages.docengine.eaa.description")}
            </p>
            <p className="mb-0">
              {i18next.t("pages.docengine.eaa.goal")}
              <br />
              {i18next.t("pages.docengine.eaa.goal2")}
              <br />
              <a
                href="./artikler/er-din-bedrift-klar"
                className="hover:underline text-contrast-ink"
              >
                {i18next.t("pages.docengine.eaa.readMore")}
              </a>
            </p>
          </div>
          <img src={EAA_logo} alt="docEngine" className="h-46" />
        </div>
      </div>

      <div className="bg-main-light py-36">
        <div className="container max-w-sm mx-auto flex flex-col justify-start text-white text-left items-start">
          <h3 className="text-3xl font-bold mb-2">
            {i18next.t("pages.docengine.benefits.title")}
          </h3>
          <p className="text-lg opacity-90">
            {i18next.t("pages.docengine.benefits.description")}
          </p>
          <Button
            variant="solid"
            color="secondary"
            size="large"
            onClick={() => {
              navigate("/skjema/book-demo");
            }}
            className="w-fit mx-auto mt-8"
          >
            {i18next.t("pages.docengine.benefits.cta")}
          </Button>
        </div>
      </div>

      <div className="bg-gray py-36">
        <div className="container max-w-lg mx-auto flex flex-col md:flex-row justify-center items-center text-main-dark text-left ">
          <div className=" w-full md:w-3/5">
            <p className="text-xl mb-2 font-bold">
              {i18next.t("pages.docengine.partner.title")}
            </p>
            <p className="text-xl mb-0">
              {i18next.t("pages.docengine.partner.description")}
            </p>
          </div>
          <div className="w-full md:w-2/5 flex justify-center items-center py-8">
            <Button
              variant="solid"
              color="contrast"
              size="large"
              onClick={() => {
                navigate("/skjema/kontakt-oss");
              }}
            >
              {i18next.t("pages.docengine.partner.cta")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DocEngine;
